<div class="col-12-nav">
    <div class="signin-header">
        <div class="container">
            <section class="logo center-block-wrap">
                <div class="logo-white"></div>
            </section>
        </div>
    </div>
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
        size="medium"
        color="#fff"
        type="line-spin-clockwise-fade"
        [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <br>
    <div class="col-12 text-right">
        <a tabindex="0" id="en" class="btn btn-default border border-left-0 border-top-0 border-bottom-0 border-dark rounded-0" (click)="functionsService.useLanguage('en')">EN <span class="sr-only">Change language to English</span></a>
        <a tabindex="0" id="es" class="btn btn-default" (click)="functionsService.useLanguage('es')">ES <span class="sr-only">Cambiar idioma a español</span></a>
    </div>
    <div id="forgotPass" class="img-bg">
        <div class="row justify-content-center">
            <div class="col-12 text-center mb-3">
                <h3>{{'password.forgot_pass' | translate}}</h3>
            </div>
            <br/>
            <form [formGroup]="forgotPasswordForm" class="mw-351" (ngSubmit)="forgotPassword()"
                name="form">
                <div class="form-group">
                    <p class="text-left">{{'password.prompt_email_forgot_pass' | translate}}</p>
                    <label for="Email" class="float-left">{{'general.email' | translate}}<span class="error">*</span></label>
                    <input id="Email" (click)="clearErrorMessage()" type="text" formControlName="Email" class="form-control input-creds"
                        required="required" [ngClass]="{ 'is-valid': Email['valid'], 'is-invalid': Email['invalid'] }"/>
                    <ng-container *ngIf="forgotPasswordForm.get('Email').invalid && (forgotPasswordForm.get('Email').touched || forgotPasswordForm.get('Email').dirty || formSubmitted)">
                        <div *ngIf="forgotPasswordForm.get('Email').hasError('required')"  class="error align-left">
                            {{'general.required_field' | translate}}
                        </div>
                        <div *ngIf="forgotPasswordForm.get('Email').hasError('pattern')"  class="error align-left">
                            {{'general.invalid_email' | translate}}
                        </div>
                    </ng-container>
                    <div id="forgotEmailError" class="error text-center mt-2"></div>
                </div>
                <div class="form-group" class="text-center">
                    <input type="submit" class="btn btn-alertia btn-green btn-h-green btn-login" title="{{'password.send_email' | translate}}" value="{{'password.send_email' | translate}}">
                    <br><br>
                    <a href="/login" class="custom-hyperlink"><u>{{ 'general.back_to_login' | translate}}</u></a>
                </div>
            </form>
        </div>
    </div>
    <div id="forgotEmailSent" class="img-background">
        <div class="row justify-content-center">
            <div class="col-12 text-center mb-3">
                <h4>{{'password.forgot_email_sent' | translate}}</h4>
            </div>
            <br/>
            <form [formGroup]="tempPasswordForm" class="mw-351" (ngSubmit)="tempPassword()" name="form">
                <div class="form-group">
                    <label for="Password" class="float-left">{{'password.validation_code' | translate}}<span class="error">*</span></label>
                    <input id="Password" type="text" formControlName="Password" class="form-control input-creds" required="required" [ngClass]="{ 'is-valid': Password['valid'], 'is-invalid': Password['invalid'] }" />
                    <ng-container *ngIf="tempPasswordForm.get('Password').invalid && (tempPasswordForm.get('Password').touched || tempPasswordForm.get('Password').dirty || formSubmittedVC)">
                        <div *ngIf="tempPasswordForm.get('Password').hasError('required')"  class="error align-left">
                            {{'general.required_field' | translate}}
                        </div>
                    </ng-container>
                    <div id="invalidTempPass" class="text-danger"></div>
                </div>
                <div class="form-group">
                    <input type="submit" class="btn btn-alertia btn-green btn-h-green btn-login" title="{{'password.verify_code' | translate}}" value="{{'password.verify_code' | translate}}" >
                </div>
            </form>
            <br>
            <div class="col-12 text-center">
                <a href="/login" class="custom-hyperlink"><u>{{ 'general.back_to_login' | translate}}</u></a>
            </div>
        </div>
    </div>
</div>
